import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { isFunction, isString } from '@dateam/ark';
var TokenStore = /*#__PURE__*/function () {
  function TokenStore() {
    _classCallCheck(this, TokenStore);
    this._store = void 0;
    this._isStoreInit = false;
    this._storeKey = 'AUTH_TOKEN';
  }
  return _createClass(TokenStore, [{
    key: "get",
    value: function get() {
      if (!this._isStoreInit) throw new Error('TokenStore: a store should be set using setStore');
      var token;
      try {
        token = this._store.get(this._storeKey);
      } catch (err) {
        throw new Error('TokenStore: no token found from store');
      }

      // if (!isString(token)) throw new Error('TokenStore: retrieved token is not valid');

      return token || null;
    }
  }, {
    key: "set",
    value: function set(token) {
      if (!this._isStoreInit) throw new Error('TokenStore: a store should be set using setStore');
      if (!isString(token)) throw new Error('TokenStore: provided token is not valid');
      try {
        this._store.set(this._storeKey, token);
      } catch (err) {
        throw new Error('unable to save token into storage');
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      if (!this._isStoreInit) throw new Error('TokenStore: a store should be set using setStore');
      try {
        this._store.clear(this._storeKey);
      } catch (err) {
        throw new Error('TokenStore: unable to clear token from store');
      }
    }
  }, {
    key: "setStore",
    value: function setStore(store) {
      if (isFunction(store === null || store === void 0 ? void 0 : store.get) && isFunction(store === null || store === void 0 ? void 0 : store.set) && isFunction(store === null || store === void 0 ? void 0 : store.clear)) {
        this._store = store;
        this._isStoreInit = true;
      }
      return this;
    }
  }, {
    key: "setTokenKey",
    value: function setTokenKey(key) {
      if (isString(key) && key.trim().length > 0) this._storeKey = key;
      return this;
    }
  }]);
}();
export default TokenStore;